import i18n from "shared/i18n";

const validate = values => {
  const errors = {};

  if (!values.old_password) {
    errors.old_password = i18n.t("Current password should not be blank");
  }

  if (!values.password) {
    errors.password = i18n.t("New password should not be blank");
  } else if (values.old_password === values.password) {
    errors.password = i18n.t("This is your current password!");
  } else if(values.password.length < 8) {
    errors.password = i18n.t("New password must contain at least 8 characters");
  }

  if (!values.password2) {
    errors.password2 = i18n.t("Confirmation password should not be blank");
  } else if (values.password2.length < 8) {
    errors.password2 = i18n.t("New password must contain at least 8 characters");
  }

  if (values.password && values.password2 && values.password !== values.password2) {
    errors.password2 = i18n.t("Password fields did not match");
  }

  return errors;
};

export default validate;
